import {SimpleItem} from "./SimpleItem";
import {OrderDeliverTo} from "../../../../model/OrderDeliverTo";
import {AddressValidationOrder} from "../../../../model/AddressValidationOrder";

export class SimpleOrder extends AddressValidationOrder {
  orderId: string;
  type: string;
  ignored: boolean;
  confirmed: boolean;

  items: SimpleItem[] = [];
  currency: string;
  ecommerceConnectionId: number;
  orderDate: string;
  submissionMethod: string;
  // email: string;
  // telephone: string;
  // address1: string;
  // address2: string;
  // address3: string;
  // address4: string;
  // city: string;
  // postalCode: string;
  // region: string;
  // country: string;
  // title: string;
  // firstName: string;
  // lastName: string;
  // company: string;
  // shippingInfo: string;
  // verifiedAddress1: string;
  // verifiedAddress2: string;
  // verifiedCity: string;
  // verifiedRegion: string;
  // verifiedPostalCode: string;
  // verifiedCountry: string;
  // editedAddress1: string;
  // editedAddress2: string;
  // editedCity: string;
  // editedPostalCode: string;
  // editedRegion: string;
  // editedCountry: string;
  inventoryType: string;
  orderDeliverTo: OrderDeliverTo;

  // edit: boolean = false;
  //
  // manualAddressValidationStatus: string = '';
  // addressToUse = 'ORIGINAL';  // Also 'VERIFIED' and 'EDITED'
  //
  // verifiedStatus: string;
  // verifiedResponse: string;
  // public addressValidationResult: AddressValidationResult;
  // verifiedAddressSetByUser: boolean = false;


  saving: boolean = false;
  created: boolean = false;

  constructor () {
    super();
    this.orderId = '';
    this.type = 'String';
    this.ignored = false;
    this.confirmed = false;
  }


  setOrderId (orderId: string) {
    this.orderId = orderId;
  }

  setCurrency (currency: string) {
    this.currency = currency;
  }

  setEcommerceConnection (ecommerceConnectionId: number) {
    this.ecommerceConnectionId = ecommerceConnectionId;
  }

  setOrderDate (orderDate: string) {
    this.orderDate = orderDate;
  }

  setSubmissionMethod (submissionMethod: string) {
    this.submissionMethod = submissionMethod;
  }

  setEmail (email: string) {
    this.email = email;
  }

  setPhone (telephone: string) {
    this.telephone = telephone;
  }

  setStreet (address1: string) {
    this.address1 = address1 ? address1.toUpperCase() : '';
  }

  setAddress2 (address2: string) {
    this.address2 = address2 ? address2.toUpperCase() : '';
  }

  setAddress3 (address3: string) {
    this.address3 = address3 ? address3.toUpperCase() : '';
  }

  setAddress4 (address4: string) {
    this.address4 = address4 ? address4.toUpperCase() : '';
  }

  setCity (city: string) {
    this.city = city ? city.toUpperCase() : '';
  }

  setPostalCode (postalCode: string) {
    this.postalCode = postalCode;
  }

  setRegion (region: string) {
    this.region = region ? region.toUpperCase() : '';
  }

  setCountry (country: string) {
    this.country = country;
  }

  setTitle (title: string) {
    this.title = title;
  }

  setFirst (firstName: string) {
    this.firstName = firstName;
  }

  setLast (lastName: string) {
    this.lastName = lastName;
  }

  setCompany (company: string) {
    this.company = company;
  }

  setShippingInfo (shippingInfo: string) {
    this.shippingInfo = shippingInfo;
  }

  addItem (item: SimpleItem) {
    this.items.push(item);
  }


  addOrderItems (simpleOrder: SimpleOrder) {
    // NOTE: this used to read
    //   this.lastName = simpleOrder.firstName ? simpleOrder.firstName : '' + " " + simpleOrder.lastName ? simpleOrder.lastName : '';
    // which, because `?:` binds looser than `+`, collapsed to just
    // `simpleOrder.firstName` — so merging two rows that ship to the same
    // address overwrote THIS order's surname with the OTHER row's first name.
    // The surviving order now keeps its own recipient untouched.
    // TODO: when two rows for one address name different people, we currently
    // keep only the first recipient. Confirm the desired behaviour with the
    // business before combining or listing both names.
    simpleOrder.items.forEach( item => {
      let foundSameItem = false;
      for ( const localItem of this.items ) {
        if ( localItem.id === item.id ) {
          foundSameItem = true;
          localItem.quantity += localItem.quantity;
        }
      }
      if ( !foundSameItem ) {
        this.items.push(item);
      }
    });
  }

  isSameAddress (simpleOrder: SimpleOrder) {
    // If the two unvalidated addresses are identical then it is the same address
    try {
      if ( this.address1 === simpleOrder.address1 && this.address2 === simpleOrder.address2 && this.city === simpleOrder.city && this.region === simpleOrder.region && this.postalCode === simpleOrder.postalCode ) {
        return true;
      }
    } catch (err) {}

    // If either did not get validated or if either does not have an address1 then they are not the same address
    if ( !this.addressValidationResult || !simpleOrder.addressValidationResult || !this.verifiedAddress1 || !simpleOrder.verifiedAddress1 ) {
      return false;
    }
    try {
      if ( this.verifiedAddress1 === simpleOrder.verifiedAddress1 && this.verifiedAddress2 === simpleOrder.verifiedAddress2 && this.verifiedCity === simpleOrder.verifiedCity && this.verifiedRegion === simpleOrder.verifiedRegion && this.verifiedPostalCode === simpleOrder.verifiedPostalCode ) {
        return true;
      }
    } catch (err) {}
    return false;
  }

}
